import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from "../services/setupInterceptors";

export const fetchProductReviews = createAsyncThunk(
  "reviews/fetchProductReviews",
  async ({ productId, page = 1, pageSize = 10 }, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        `/product-reviews/${productId}?page=${page}&page_size=${pageSize}`
      );
      return response.data.data; 
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const postProductReview = createAsyncThunk(
  "reviews/postProductReview",
  async (reviewData, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post("/product-reviews/", reviewData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const uploadReviewImages = createAsyncThunk(
  "reviews/uploadReviewImages",
  async ({ reviewId, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        `/product-reviews/${reviewId}/images`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const reviewsSlice = createSlice({
  name: "reviews",
  initialState: {
    reviews: [], // list of reviews
    images: [], // all review images if returned
    total: 0,
    totalPages: 0,
    currentPage: 1,
    pageSize: 10,

    loading: false,
    error: null,
    lastUploadedImages: [],
  },
  reducers: {
    clearReviewsState: (state) => {
      state.reviews = [];
      state.images = [];
      state.total = 0;
      state.totalPages = 0;
      state.currentPage = 1;
      state.error = null;
      state.lastUploadedImages = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductReviews.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductReviews.fulfilled, (state, action) => {
        state.loading = false;
        state.reviews = action.payload.data || [];
        state.images = action.payload.images || [];
        state.total = action.payload.total || 0;
        state.totalPages = action.payload.total_pages || 0;
        state.currentPage = action.payload.current_page || 1;
        state.pageSize = action.payload.page_size || 10;
      })
      .addCase(fetchProductReviews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(postProductReview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postProductReview.fulfilled, (state, action) => {
        state.loading = false;
      
      })
      .addCase(postProductReview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(uploadReviewImages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadReviewImages.fulfilled, (state, action) => {
        state.loading = false;
       
      })
      .addCase(uploadReviewImages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearReviewsState } = reviewsSlice.actions;
export default reviewsSlice.reducer;
